import { productsRepository } from '~/api/repository/products';

export const PRODUCTS_QUERY_KEY = {
  all: ['products'] as const,

  // 유사 상품 목록
  similar: (offerId: number) => ({
    queryKey: ['/api/market-place/v1/similar/products', offerId] as const,
    queryFn: () => productsRepository.getSimilarProducts(offerId),
  }),

  // 함께 구매하는 상품(교차판매) 목록
  crossSell: (offerId: number) => ({
    queryKey: [
      '/api/market-place/v1/cross-sell/{offerId}/products',
      offerId,
    ] as const,
    queryFn: () => productsRepository.getCrossSellProducts(offerId),
  }),

  // 최근 본 상품 목록
  recentlyViewed: () => ({
    queryKey: [
      '/api/market-place/v1/products/recently-viewed-products',
    ] as const,
    queryFn: () => productsRepository.getRecentlyViewedProducts(),
  }),

  // 상품 상세
  detail: (offerId: number) => ({
    queryKey: [
      '/api/market-place/v2/products/{offerId}/details',
      offerId,
    ] as const,
    queryFn: () => productsRepository.getProductDetail(offerId),
  }),

  // 상품 옵션 목록
  options: (offerId: number) => ({
    queryKey: [
      '/api/market-place/v2/products/{offerId}/options',
      offerId,
    ] as const,
    queryFn: () => productsRepository.getProductOptions(offerId),
  }),
};
